import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedProviderModule } from '~app/shared/shared.module';

@NgModule({
  declarations: [],
  imports: [ CommonModule, SharedProviderModule ],
  exports: [],
  providers: [],
})
export class NeveMeasurementsModule {}
